import * as React from "react";
import { createContext } from "react";

type ConsentContextValue = {
  consentHandler: () => Promise<void>;
};

export interface ConsentContextProps extends ConsentContextValue {
  children: any;
}

const ConsentContext = createContext<ConsentContextValue>({
  consentHandler: () => Promise.resolve(),
});

export function ConsentContextProvider({ consentHandler, children }: ConsentContextProps) {
  return <ConsentContext.Provider value={{ consentHandler }}>{children}</ConsentContext.Provider>;
}
